import React from 'react'
import { Outlet } from 'react-router-dom'
import { useSiteContext } from '@contexts/MkSiteContext'
import { MkThemeSwitcher } from '@ui/ThemeSwitcher/MkThemeSwitcher'
import { SiteNav } from './SiteNav'
import { SiteFooter } from './SiteFooter'
import './MaintenanceLayout.scss'

/**
 * Minimal chrome for maintenance: logo-only header, legal strip only footer.
 */
export const MaintenanceLayout: React.FC = () => {
  const { themeBrand } = useSiteContext()
  const themeToken = (themeBrand || '').toLowerCase() === 'ev' ? 'ebac' : themeBrand
  const showDevThemeSwitcher = process.env.NODE_ENV === 'development'

  return (
    <div
      id="theme-root"
      className="maintenance-layout"
      data-theme={themeToken}>
      <a
        href="#mainView"
        className="skip-link"
        tabIndex={0}>
        Skip to main content
      </a>

      {showDevThemeSwitcher && <MkThemeSwitcher />}

      <SiteNav
        brand={themeBrand}
        logoOnly
      />

      <main
        id="mainView"
        className="main-view">
        <Outlet />
      </main>

      <SiteFooter
        brand={themeBrand}
        minimal
      />
    </div>
  )
}
